import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

export enum EnSuketCategory {
  SehatTht = "sehat-tht",
  SehatParu = "sehat-paru",
  SehatMata = "sehat-mata",
  LayakTerbang = "layak-terbang",
  FitToWork = "fit-to-work",
  LayakVaksin = "layak-vaksin",
  Vaksin = "vaksin",
  SehatDalam = "sehat-dalam",
  SehatGigi = "sehat-gigi",
  PemeriksaanGigiMulut = "pemeriksaan-gigi-mulut",
  McuGigiMulut = "mcu-gigi-mulut",
  KlaimProtesaGigi = "klaim-protesa-gigi",
  McuUmum = "mcu-umum",
  McuGol2 = "mcu-gol-2",
  Disabilitas = "disabilitas",
  TidakCacat = "tidak-cacat",
  TatoTindik = "tato-tindik",
  KulitKelamin = "kulit-kelamin",
  Dirawat = "dirawat",
  Pulang = "pulang",
  SkdAdopsi = "skd-adopsi",
  Skbpm = "skbpm",
  Form77 = "form-77",
  McuCpnsGol3 = "mcu-cpns-gol3",
  SkmAsuransi = "skm-asuransi",
  TindakanUmum = "tindakan-umum",
  TindakanHd = "tindakan-hd",
  PenanggungjawabBayi = "penanggungjawab-bayi",
  KesanggupanDirujuk = "kesanggupan-dirujuk",
  SuratKeteranganMedis = "surat-keterangan-medis",
  PengawetanJenazah = "pengawetan-jenazah"
}

class CommonSuket {
  category: string = null;

  constructor(cat: string) {
    this.category = cat;
  }

  async create(data) {
    const response = await http
      .postData(`/suket/${this.category}`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response;
  }

  async update(id, data) {
    const response = await http
      .putData(`/suket/${this.category}/${id}`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response;
  }

  async getByRegister(register_id: string | number) {
    const response = await http
      .getData(`/register/${register_id}/suket/${this.category}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async find(id: number) {
    const response = await http
      .getData(`/suket/${this.category}/${id}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async destroy(id: number) {
    const response = await http
      .deleteData(`/suket/${this.category}/${id}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async sign(id: number, data) {
    const response = await http
      .postData(`/suket/${this.category}/${id}/signature`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  print(id) {
    window.open(`${http.getAPI()}/suket/${this.category}/${id}/pdf`, "_blank");
  }
}

export default CommonSuket;
